import "../css/globals.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-number-input/style.css";
import "react-loading-skeleton/dist/skeleton.css";

import type { AppProps } from "next/app";

import { config } from "server/config";
import { initializeDatadogRum } from "observability";
import { trpc } from "utils/trpc";
import { fontSans } from "lib/fonts";
import { cn } from "utils/cn";

if (config().NODE_ENV === "development") import("lib/dev-helpers");

initializeDatadogRum();

type AppPropsWithUser = AppProps & {
  pageProps: {
    user: any;
  };
};
function App({ Component, pageProps }: AppPropsWithUser) {
  return (
    <main className={cn("min-h-screen font-sans", fontSans.variable)}>
      <Component {...pageProps} />
    </main>
  );
}

export default trpc.withTRPC(App);
